export default {
  text: '#020303',
  primary: '#028682',
  secondary: '#ef4036',
  background: '#fff5e9',
  backgroundSecondary: '#1eb3c9',
  light: '#fdfdfd',
  dark: '#020303'
}
